module.exports = __webpack_public_path__ + "img/founders-five.0422fdd8.png";